<!--
  ナビゲーターの親コンポーネントです
  左側の１つめ(常に表示されている部分)はそのまま記述されています。
  コンポーネント化しようとしたけど無理だった
-->
<template>
  <div>
    <nvgtop
      v-if="['home','workspace','dashboard'].includes(routeName)"
      :pageTitle="pageTitle"
      :uid="uid"
      :profImageS="profImageS"
      :unfold="unfold"
    ></nvgtop>
    <nvgtop2
      v-else-if="pjdialogtf!==true"
      :pageTitle="pageTitle"
      :uid="uid"
      :profImageS="profImageS"
      :unfold="unfold"
    ></nvgtop2>
    <nvgleft2 v-if="!['home','workspace','dashboard'].includes(routeName) && pjdialogtf!==true" :selectedItem="selectedItem"></nvgleft2>

    <v-navigation-drawer
      class="navdrawer"
      app
      :mini-variant.sync="unfold"
      permanent
      color="#294A66"
      dark
      width="312px"
      mini-variant-width="80px"
      stateless
      :style="{ 'z-index': isZ ? '600' : '15', 'padding-bottom': bottomareaHeight() }"
      style="overflow-y: auto;"
    >
      <div class="d-flex align-center mx-0" style="width:100%;">
        <router-link to="/home" style="text-decoration:none;cursor:pointer;" class="d-flex align-center pr-2" @click="wsbtn('home')">
          <v-avatar
            size="40"
            tile
            class="rounded-circle"
            :class="{ 'ml-4': !unfold, 'ml-1': unfold }"
            style="border:solid #294A66"
          >
            <v-img
              v-if="logoSrc&&logoSrc!=='none'"
              class="preview-item-file"
              :src="logoSrc"
              alt=""
            />
            <v-img
              src="../assets/logo/logo.png"
              class="preview-item-file"
              alt=""
              v-else
            />
          </v-avatar>
          <h3 class="white--text mr-auto ml-5" v-if="!unfold">{{basetitle}}</h3>
        </router-link>
        <v-btn
          class="ml-auto"
          icon
          x-large
          @click="unfold = !unfold"
          height="60px"
        >
          <span v-if="!unfold" class="mr-2"><v-icon style="color: white">mdi-chevron-left</v-icon></span>
          <v-icon v-else class="mr-6" style="color: white">mdi-chevron-double-right</v-icon>
        </v-btn>
      </div>
      <!-- WSが作られている場合 -->
      <div v-if="wss&&wss.length">
        <!--ホーム-->
        <v-list class="pb-0 pt-0" :class="{ selectedBack: routeName=='home' }" @click="today()">
          <router-link to="/home" style="text-decoration:none;">
            <v-list-item class="pb-0 listgroup">
              <v-list-item-icon class="pt-2">
                <v-img
                  src="../assets/svg/home.svg"
                  alt=""
                  width="35px"
                ></v-img>
              </v-list-item-icon>
              <v-list-item-content class="ml-6">
                <v-list-item-title :class="{ selectedFont: routeName=='home' }" style="font-size:18px;">
                  ホーム
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list>
        <!-- WS一覧 -->
        <v-list no-action class="ws py-0 ">
          <v-list-group no-action v-model="isWsOpen" class="ws">
            <template v-slot:activator>
              <v-list-item-title v-if="!unfold" class="selectedFont" style="font-size:18px; display: flex; flex-direction: column;">
                <span :style="eachWs&&!isWsOpen ? 'font-size:8px' : ''">ワークスペース</span><span v-if="eachWs&&!isWsOpen" style="margin-left: 8px">{{ eachWs.title }}</span>
              </v-list-item-title>
            </template>
            <div class="noneScBar d-flex flex-column overflow-y-auto overflow-x-hidden">
              <div v-for="ws in wss" :key="ws.sort" @click="wsbtn(ws),isWsOpen=false" class="py-2 px-5" :class="{ selectedBack: paramsId==ws.id }">
                <router-link :to="'/workspace/'+ ws.id" style="text-decoration:none;">
                  <v-icon style="margin-left: 3px; margin-right: 29px;" color="white">mdi-microsoft</v-icon>
                  <span class="selectedFont" style="font-size:16px;">{{ ws.title.substr(0, 12) }}</span>
                </router-link>
              </div>
            </div>
          </v-list-group>
        </v-list>
        <!-- WSが選択されている場合 -->
        <div v-if="eachWs">
          <v-divider color="white" class="mx-4 my-2"></v-divider>
          <div class="pa-0" style="max-height: 35vh;">
            <!-- <p class="px-4 my-4 selectedFont" v-if="eachWs&&eachWs.title" style="font-size:18px;">{{ eachWs.title.substr(0, 24) }}</p> -->
            <!--取り組みについて(旧ホーム)-->
            <router-link :to="'/workspace/' + eachWs.id" style="text-decoration:none;">
              <div class="py-2 px-5 d-flex align-center" @click="wsbtn(eachWs)"  :class="{ selectedBack: routeName=='workspace' }">
                <v-icon style="margin-left: 3px; margin-right: 29px;" color="white">mdi-file-document-outline</v-icon>
                <span v-if="!unfold" class="selectedFont" style="font-size:16px;">取り組みについて</span>
              </div>
            </router-link>
            <!--ダッシュボード-->
            <router-link :to="'/dashboard?id=' + eachWs.id" style="text-decoration:none;">
              <div class="py-2 px-5 d-flex align-center" @click="wsbtn(eachWs)" :class="{ selectedBack: routeName=='dashboard' }">
                <v-icon style="margin-left: 3px; margin-right: 29px;" color="white">mdi-pin</v-icon>
                <span v-if="!unfold" class="selectedFont" style="font-size:16px;">ダッシュボード</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- WSが作られていない場合 -->
      <div v-else>
        <!--ホーム-->
        <v-list class="pb-0 pt-0" :class="{ selectedBack: routeName=='home' }" @click="today()">
          <router-link to="/home" style="text-decoration:none;">
            <v-list-item class="pb-0 listgroup">
              <v-list-item-icon class="pt-2">
                <v-img
                  src="../assets/svg/home.svg"
                  alt=""
                  width="35px"
                ></v-img>
              </v-list-item-icon>
              <v-list-item-content class="ml-6">
                <v-list-item-title :class="{ selectedFont: routeName=='home' }">
                  ホーム
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list>
        <!--dashboard-->
        <v-list class="pb-0 pt-0" :class="{ selectedBack: routeName=='dashboard' }" @click="today()">
          <router-link to="/dashboard" style="text-decoration: none;">
            <v-list-item class="pb-0 listgroup">
              <v-list-item-icon class="pt-2">
                <v-img
                  src="../assets/svg/pin.svg"
                  alt=""
                  width="35px"
                ></v-img>
              </v-list-item-icon>
              <v-list-item-content class="ml-6">
                <v-list-item-title :class="{ selectedFont: routeName=='dashboard' }">ダッシュボード</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list>
      </div>
      <!--Lid一覧-->
      <v-list class="pt-0 overflow-y-auto overflow-x-hidden noneScBar">
        <div v-for="item in navlid" :key="item.id">
          <v-list-group v-if="(paramsId === item.id)||item.isfolder||navigationLidType=='dropdown'" no-action class="pt-3" :class="{ navilidr: paramsId === item.id }">
            <template v-slot:activator>
              <v-list-item-content>
                <v-row>
                  <v-col cols="3">
                    <v-icon v-if="item.isfolder" style="border:4px solid white">mdi-folder-outline</v-icon>
                    <!-- isOpenがprivateならiconもつけるが、そうでないならiconなし -->
                    <v-badge v-else-if="item.isNotiIdea&&isAuthed"
                      color="deepLava"
                      overlap
                      :icon="item.isOpen=='private'
                        ? (item.isOpenForGovStaff && authConfig.officer)
                          ? 'mdi-office-building-outline'
                          : 'mdi-shield-lock-open-outline'
                        : ''
                      "
                    >
                      <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                    </v-badge>
                    <v-badge v-else-if="item.isOpen=='private'"
                      color="faintHoney"
                      :icon="(item.isOpenForGovStaff && authConfig.officer) ? 'mdi-office-building-outline' : 'mdi-shield-lock-open-outline'"
                      overlap
                    >
                      <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                    </v-badge>
                    <v-btn v-else icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-col>
                  <v-col cols="9" class="d-flex align-center rounded-l-pill" style="margin-left:-7px" v-if="!unfold" :class="{ thispage: paramsId === item.id }">
                    <v-list-item-title
                      style="width: 150px;white-space:normal;"
                    >{{ item.title }}
                    </v-list-item-title>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </template>
            <v-row v-if="item.isfolder">
              <v-col cols="2"></v-col><v-col cols="10">
                <v-list-item v-for="childitem in item.childlids" :key="childitem.id" class="pr-0">
                  <v-menu right offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="#008CFF"
                        class="childitembtn"
                        dark
                        width="100%"
                        height="60px"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ childitem.title }}
                      </v-btn>
                    </template>
  
                    <v-list elevation="10" style="background-color: #E0E0E0" @click="today()">
                      <router-link :to="'/lid/' + childitem.id + '/content'" style="text-decoration:none;">
                        <v-list-item class="pr-0">
                          <v-list-item-icon class="pt-2">
                            <v-icon color="#008CFF" width="10px">mdi-information-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content class="pl-2">
                            <v-list-item-title
                              style="color: #294A66"
                              class="rounded-l-pill py-2 pl-2"
                              >{{childitem.zenteiJohoName ? childitem.zenteiJohoName : childitem.zenteiJohoToProjectKaigi ? '会議の内容' : $t('前提情報')}}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </router-link>
                      <router-link :to="'/lid/' + childitem.id + '/idea'" style="text-decoration:none;" v-if="!(hideConfig.idea)&&!(childitem&&childitem.ideaHidden)">
                        <v-list-item class="pr-0">
                          <v-list-item-icon class="pt-2">
                            <v-img
                              src="../assets/svg/3012.svg"
                              alt=""
                              width="10px"
                            ></v-img>
                          </v-list-item-icon>
                          <v-list-item-content class="pl-2">
                            <v-list-item-title
                              style="color: #294A66"
                              class="rounded-l-pill py-2 pl-2"
                              >{{$t('アイデア')}}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </router-link>
                      <router-link :to="'/lid/' + childitem.id + '/project'" style="text-decoration:none;" v-if="!(hideConfig.project)&&!(childitem&&childitem.projectHidden)">
                        <v-list-item class="pr-0">
                          <v-list-item-icon class="pt-2">
                            <v-img
                              src="../assets/svg/3013.svg"
                              alt=""
                              width="10px"
                            ></v-img>
                          </v-list-item-icon>
                          <v-list-item-content class="pl-2">
                            <v-list-item-title
                              style="color: #294A66"
                              class="rounded-l-pill py-2 pl-2"
                              >{{childitem.kaizenTeianEnabled ? '改善提案シート' : $t('プロジェクト')}}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </router-link>
                    </v-list>
                  </v-menu>
              </v-list-item>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="2"></v-col>
              <v-col cols="10" @click="today()">
                <router-link :to="'/lid/' + item.id + '/content'" style="text-decoration:none;">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-icon color="#008CFF" v-if="conttf && paramsId === item.id" width="10px">mdi-information-outline</v-icon>
                      <v-icon color="#008CFF" v-else width="10px">mdi-information-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        :class="{ select: conttf && paramsId === item.id }"
                        style="color: #ffffff"
                        class="rounded-l-pill py-2 pl-2"
                        >{{item.zenteiJohoName ? item.zenteiJohoName : item.zenteiJohoToProjectKaigi ? '会議の内容' :  $t('前提情報')}}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
                <router-link :to="'/lid/' + item.id + '/idea'" style="text-decoration:none;" v-if="!(hideConfig.idea)&&!(item&&item.ideaHidden)">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-img
                        v-if="ideatf && paramsId === item.id"
                        src="../assets/svg/3012.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                      <v-img
                        v-else
                        src="../assets/svg/3012.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        :class="{ select: ideatf && paramsId === item.id }"
                        :style="item.isNotiIdea&&isAuthed ? 'color: #E64550' : 'color: #ffffff'"
                        class="rounded-l-pill py-2 pl-2"
                        >{{$t('アイデア')}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
                <router-link :to="'/lid/' + item.id + '/project'" style="text-decoration:none;" v-if="!(hideConfig.project)&&!(item&&item.projectHidden)">
                  <v-list-item class="pr-0">
                    <v-list-item-icon class="pt-2">
                      <v-img
                        v-if="pjtf && paramsId === item.id"
                        src="../assets/svg/3013.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                      <v-img
                        v-else
                        src="../assets/svg/3013.svg"
                        alt=""
                        width="10px"
                      ></v-img>
                    </v-list-item-icon>
                    <v-list-item-content class="pl-2">
                      <v-list-item-title
                        :class="{ select: pjtf && paramsId === item.id }"
                        style="color: #ffffff"
                        class="rounded-l-pill py-2 pl-2"
                        >{{item.kaizenTeianEnabled ? '改善提案シート' : $t('プロジェクト')}}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
              </v-col>
            </v-row>
          </v-list-group>
          <v-list-item v-else class="pt-3">
            <router-link :to="'/lid/' + item.id + '/idea'" style="color:white;text-decoration:none;">
              <v-row>
                <v-col cols="3">
                  <v-icon v-if="item.isfolder" style="border:4px solid white">mdi-folder-outline</v-icon>
                  <!-- isOpenがprivateならiconもつけるが、そうでないならiconなし -->
                  <v-badge v-else-if="item.isNotiIdea&&isAuthed"
                    color="deepLava"
                    overlap
                    :icon="item.isOpen=='private'
                        ? (item.isOpenForGovStaff && authConfig.officer)
                          ? 'mdi-office-building-outline'
                          : 'mdi-shield-lock-open-outline'
                        : ''
                      "
                  >
                    <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-badge>
                  <v-badge v-else-if="item.isOpen=='private'"
                    color="faintHoney"
                    :icon="(item.isOpenForGovStaff && authConfig.officer) ? 'mdi-office-building-outline' : 'mdi-shield-lock-open-outline'"
                    overlap
                  >
                    <v-btn icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                  </v-badge>
                  <v-btn v-else icon class="lidbtn" style="border:3px solid white; font-size: 8px;" elevation="3" >{{ item.title.substr(0, 2) }}</v-btn>
                </v-col>
                <v-col cols="9" class="d-flex align-center rounded-l-pill" v-if="!unfold" :class="{ thispage: paramsId === item.id }">
                  <v-list-item-title
                    style="width: 150px;white-space:normal;"
                  >{{ item.title }}
                  </v-list-item-title>
                </v-col>
              </v-row>
            </router-link>
          </v-list-item>
        </div>
      </v-list>
      <!--Lid追加-->
      <v-list v-if="isAdmin" class="pt-0">
        <v-list-item
          @click="addLid = true"
          class="mt-0 mb-4"
        >
          <v-list-item-icon>
            <v-icon large color="">mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title data-testid="gotoAddLid" style="color: white">{{ $t('Lid') }}を追加</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!--左下固定部-->
      <!-- 親要素に同じ高さでpadding-bottomを設定している -->
      <v-card class="bottomarea d-flex flex-column pl-2" :height="bottomareaHeight()" width="312px" tile style="background-color: #294A66;">
        <v-divider></v-divider>
        <!--プロフィールボタン-->
        <div class="mt-auto mb-2"  v-if="isAuthed" style="font-size: 20px; color: #ffffff">
          <v-btn
            text
            class="pl-1"
            style="background-color: #294a66"
            data-testid="gotosettings"
            @click="(profile = true), setProfile(uid), (appbarpro = true),unfold=false"
          >
            <!--アカウント画像-->
            <v-img
              v-if="profImageS"
              class="preview-item-file rounded-circle"
              width="40px"
              height="40px"
              :src="profImageS"
              alt=""
            ></v-img>
            <v-img
              v-else
              src="../assets/svg/プロフィールアイコン.svg"
              alt=""
              width="40px"
            ></v-img>
            <p class="mb-0 ml-2" style="text-transform: none; font-size: 20px; color: #ffffff">{{ currentName }}</p>
          </v-btn>
        </div>
        <!--プロフィールボタン ログインなし-->
        <div class="mt-auto mb-2" style="font-size: 20px; color: #ffffff" v-else>
          <v-btn
            text
            class="pl-1"
            style="background-color: #294a66"
            data-testid="gotosettings"
            @click="authModal = true,unfold=false,$emit('doFold', false)"
          >
            <!--アカウント画像-->
            <v-img
              src="../assets/svg/プロフィールアイコン.svg"
              alt=""
              width="40px"
            ></v-img>
            <p class="mb-0 ml-2" style="text-transform: none; font-size: 16px; color: #ffffff">ログイン<span v-if="cityId!='jibungoto-maebashi'">/アカウント作成</span></p>
          </v-btn>
        </div>
        <!--ログアウトボタン-->
        <div class="my-2" v-if="isAuthed" style="font-size: 20px; color: #ffffff">
          <v-btn
            text
            class="pl-1"
            style="background-color: #294a66"
            @click="signout"
          >
            <v-img
              src="../assets/svg/ログアウトアイコン.svg"
              alt=""
              width="40px"
            ></v-img>
            <p class="mb-0 ml-2" style="text-transform: none; font-size: 16px; color: #ffffff">ログアウト</p>
          </v-btn>
        </div>
        <!--設定-->
        <div class="mt-2 mb-3" style="font-size: 16px; color: #ffffff;">
          <v-btn
            text
            class="pl-1"
            style="background-color: #294a66"
            data-testid="gotosettings"
            @click="(settings = true),unfold = false"
          >
            <v-img
              src="../assets/svg/設定歯車アイコン.svg"
              alt=""
              width="40px"
            ></v-img>
            <p class="mb-0 ml-2" style="text-transform: none; font-size: 16px; color: #ffffff">設定</p>
          </v-btn>
        </div>
        <div v-if="navi_updateDate" class="pa-2 text-center">
          <p class="mb-0">最終更新：{{ todayy }}</p>
        </div>
      </v-card>
    </v-navigation-drawer>

    <!--以下Dialog-->
    <div class="text-center">
      <!--サインイン画面-->
      <v-dialog v-if="!isAuthed" v-model="authModal" width="400px" height="60%">
        <auth-view
          v-if="authModal"
          :defaultView="defaultAuthView"
          @closeModal="closeAuthModal"
        >
        </auth-view>
      </v-dialog>      
      <!--Lid追加画面-->
      <v-dialog
        v-model="addLid"
        @keydown.esc="addLid = false"
        v-if="addLid"
        width="800"
        persistent
      >
        <addLidPage :admins="admins" :members="members" :namelist="namelist" :config="config" :ws="eachWs" @close="addLid = false;" @profile="oneprofile"></addLidPage>
      </v-dialog>

      <!--設定画面-->
      <v-dialog v-model="settings" width="800">
        <settings :members="members" @closeSetting="closeSettings" :isSp="false"></settings>
      </v-dialog>
      <!--メンバー画面-->
      <v-dialog v-model="memview" width="800" persistent>
        <listMem :candiMembers="members" :admins="admins" :members="members" :config="config" :isAdmin="isAdmin" mode="base" condition="display" :namelist="namelist" @listMemClose="oneaddMember" @lidCandiMems="onecandiMembers"></listMem>
      </v-dialog>
      <!--ベース管理者の管理画面-->
      <v-dialog v-model="adminsview" width="800" persistent>
        <listAdm 
        :candiMembers="members" 
        :admins="admins" 
        :isAdmin="isAdmin"
        :basetitle="basetitle" 
        :namelist="namelist" 
        mode="base" 
        condition="display" 
        @listAdmClose="oneaddAdmin"
      ></listAdm>
      </v-dialog>
      <!--プロフィール画面-->

      <profile_display
        :profile="profile"
        :profuid="uid"
        device="pc"
        @closeProfile="closeProfile"
      />
      <!-- 初期・通知確認画面 -->
      <firstUserSetting v-if="askForNotificationModalOpened&&!attributionModalOpened" />
      <!-- アンケート画面 -->
      <attribution v-if="attributionModalOpened" />
      <!-- 重要なお知らせ画面 -->
      <importantAnnounce v-if="importantAnnounceModalOpened" />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
const addLidPage = () => import('./addLid.vue');
const profile_display = () => import('./profile/profile_display.vue');
const nvgtop = () => import('./navigator/nvgtop.vue');
const nvgtop2 = () => import('./navigator/nvgtop2.vue');
const nvgleft2 = () => import('./navigator/nvgleft2.vue');
const listAdm = () => import('./listAdm.vue');
const listMem = () => import('./listMem.vue');
const settings = () => import('./settings.vue');
const authView = () => import('./auth/authView.vue');
const firstUserSetting = () => import('./firstUserSetting.vue')
const attribution = () => import('./attributionSettingModal.vue')
const importantAnnounce = () => import('./importantAnnounceModal.vue')
export default {
  components: {
    addLidPage,
    listAdm,
    listMem,
    nvgleft2,
    nvgtop,
    nvgtop2,
    profile_display,
    settings,
    authView,
    firstUserSetting,
    attribution,
    importantAnnounce
  },
  props:{
    pjdialogtf: Boolean,
    isZ: Boolean
  },
  data() {
    return {
      db: null,
      authConfig: JSON.parse(process.env.VUE_APP_AUTH || '{}'),  // 例→ {line:1,slp:0,officer:1}
      hideConfig: JSON.parse(process.env.VUE_APP_HIDE || '{}'),  // 例→ {content:1,idea:0,project:1}
      condition: "add",
      uploadedImage: "../assets/png/3005.png",
      authModal: false,
      defaultAuthView: "chooseauth",
      drawer: true,
      mini: false,
      settings: false,
      addLid: false,
      items: [
        {
          action: "mdi-circle-slice-8",
          active: true,
          title: "Liquitous Inc.",
        },
      ],
      lang: "japanese",
      lidName: "",
      ideaDesc: "",
      memview: false,
      profile: false,
      profileEdit: false,
      message: "",
      hitokoto: "",
      proLink: "",
      profImageO: "",
      profImageS: "",
      profileCheck: "",
      theProfile: "",
      img_name: "",
      appbarpro: false,
      adminsview: false,
      newbasetitle: "",
      only: true,
      passwordSettings: false,
      emailSettings: false,
      unfold:false,
      todayy: "",
      isAllLid: false,
      isWsOpen: false,
      navigationLidType: process.env.VUE_APP_NAVIGATION_LID_TYPE || 'dropdown',
      cityId: process.env.VUE_APP_TEMP_CITY_ID || '',
    }
  },
  computed: {
    paramsId() {
      return this.$route.params.id;
    },
    routeName() {
      return this.$route.name;
    },
    navi_updateDate(){
      if(this.$store.state.config.setting&&this.$store.state.config.setting.navi_updateDate) return this.$store.state.config.setting.navi_updateDate
      else return false
    },
    logoSrc() {
      return this.$store.state.logoSrc;
    },
    otherMemnum: function () {
      return this.admins.gov.length - 1;
    },
    admins() {
      return this.$store.state.admins;
    },
    liqAdmins() {
      return this.$store.state.liqAdmins;
    },
    namelist() {
      return this.$store.state.namelist;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    members() {
      return this.$store.state.members;
    },
    basetitle() {
      return this.$store.state.basetitle;
    },
    wss() {
      return this.$store.getters.wss;
    },
    aboutLid(){
      if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
        return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
      } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
        return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
      } else {
        return null
      }
    },
    eachWs() {
      let id = ""
      if(this.$route.name==="dashboard"&&this.$route.query.id) id = this.$route.query.id;
      else if(this.$route.name==="workspace"&&this.paramsId) id = this.paramsId;
      else if((this.$route.name==="content"||this.$route.name==="idea"||this.$route.name==="project")&&(this.aboutLid&&this.aboutLid.wsId)) id = this.aboutLid.wsId;
      if (id) {
        return this.wss.find((el) => el.id === id);
      } else {
        return null
      }
    },
    wsId(){
      if(this.$route.name==="dashboard"&&this.$route.query.id) return this.$route.query.id
      else if(this.$route.name==="workspace"&&this.paramsId) return this.paramsId
      else return ""
    },
    lid() {
      return this.$store.state.lid;
    },
    folderlid() {
      return this.$store.getters.folderlid;
    },
    navlid() {
      const navlid = this.$store.getters.navlid;
      if (this.wss?.length) {
        // WS機能を使用している
        if (this.eachWs) {
          // WSが選択されている場合、そのWSのLidのみを返す
          // return navlid.filter((el)=>this.eachWs.lids.includes(el.id))
          // WSに含まれない、感想Lidなどを表示させるための箇所...
          return navlid.filter((el)=>this.eachWs.lids.includes(el.id)).concat(navlid.filter((el)=>!el.isWs))
        } else {
          if (this.$route.name==="content"||this.$route.name==="idea"||this.$route.name==="project") {
            return navlid.filter((el)=>!el.isWs);
          } else {
            return [];
          }
        }
      } else {
        // WS機能を使用していない
        return navlid;
      }
    },
    alid() {
      return this.$store.state.alid;
    },
    config() {
      return this.$store.state.config;
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth?.user?.displayName || "";
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    isGovStaff() {
      return this.$store.state.auth?.user?.isGovStaff || false;
    },
    askForNotificationModalOpened() {
      return this.$store.state.auth.data.askForNotificationModalOpened;
    },
    attributionModalOpened() {
      return this.$store.state.auth.data.attributionModalOpened;
    },
    importantAnnounceModalOpened() {
      return this.$store.state.importantAnnounceModalOpened;
    },
    // 場所認識用
    selectedItem(){
      if (this.$route.name === "idea") {
        return 1;
      }else if (this.$route.name === "content") {
        return 1;
      }else if (this.$route.name === "project") {
        return 2;
      }else if (this.$route.name === "dashboard") {
        return 0;
      }else if (this.$route.name === "home" || this.$route.name === "workspace") {
        return 3;
      }else{
        return 3;
      }
    },
    ideatf(){
      if (this.$route.name === "idea") {
        return true;
      }else{
        return false;
      }
    },
    pjtf(){
      if(this.$route.name === "project"){
        return true;
      }else{
        return false;
      }
    },
    conttf(){
      if (this.$route.name === "content") {
        return true;
      }else{
        return false;
      }
    },
    pageTitle(){
      if (this.$route.name === "home") {
        return "ホーム";
      } else if (this.$route.name === "workspace") {
        return "取り組みについて";
      } else if(this.$route.name === "dashboard") {
        return "ダッシュボード";
      } else {
        return this.basetitle;
      }
    },
  },
  created() {
    // routeが/homeの場合、かつworkspace機能を使っている場合、unfoldeにする
    if (this.$route.name === "home"&&this.wss.length) {
      this.unfold = true;
    }
    this.db = firebase.firestore();
    this.today()
    if (this.$route.name === "idea") {
      this.$store.dispatch("getLidMembers", this.paramsId);
    }else if (this.$route.name === "content") {
      this.$store.dispatch("getLidMembers", this.paramsId);
    }else if (this.$route.name === "project") {
      this.$store.dispatch("getLidMembers", this.paramsId);
    }
    this.profileName = this.currentName;
    if(this.isAuthed) this.getProfimg(this.uid)
  },
  mounted() {
    //console.log("created",this.pageTitle,this.currentName,this.uid)
    if (this.$route.query.account === "created" || this.$route.query.account === "reset") {
      this.authModal = true;
      this.defaultAuthView = "signin";
    }
    if (this.$route.query.account === "choose") {
      this.authModal = true;
    }
  },
  updated() {
    if (this.basetitle.length > 0 && this.only) {
      this.newbasetitle = this.basetitle;
      this.only = false;
    }
  },
  watch: {
    unfold: function(newVal, oldVal) {
      this.$emit('doFold', newVal)
    },
    isAuthed : function(newVal, oldVal) {
      // データの値が変化した時にコンソールに新しい値と古い値を出力
      if(newVal){
        this.getProfimg(this.uid);
      }
    },
    members : function(newVal, oldVal) {
      // データの値が変化した時にコンソールに新しい値と古い値を出力
      this.getProfimg(this.uid);
    },
    paramsId: function(newVal, oldVal) {
      if (this.$route.name === "idea") {
        this.$store.dispatch("getLidMembers", newVal);
      }else if (this.$route.name === "content") {
        this.$store.dispatch("getLidMembers", newVal);
      }else if (this.$route.name === "project") {
        this.$store.dispatch("getLidMembers", newVal);
      }
    },
  },
  methods: {
    wsbtn(ws){
      this.isAllLid=false
      this.unfold = false
      this.$emit('wskey', ws)
    },
    bottomareaHeight() {
      if(this.isAuthed&&this.navi_updateDate) return '210px'
      else if(this.isAuthed) return '160px'
      else if(this.navi_updateDate) return '140px'
      else return '100px'
    },
    lidHeight(){
      if(this.isAuthed&&this.navi_updateDate) return '45vh'
      else if(this.isAuthed) return '53vh'
      else if(this.navi_updateDate) return '55vh'
      else return '60vh'
    },
    toDoubleDigits(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num; 
    },
    /*
      プロフィール画面(profile_display)を閉じる関数
      コンポーネントから呼び出し
    */
    closeProfile() {
      this.profile = false;
    },
    oneprofile(el) {
      //console.log("oneprofile" + el);
      this.profile = true;
      this.setProfile(el);
    },
    getProfimg(uid){
      //console.log("getpro",uid,this.isAuthed)
      this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(uid)
          .get()
          .then((doc) => {
            //プロフィールの取得
            this.profImageO = doc.data().profImageO;
            this.profImageS = doc.data().profImageS;
            //console.log("getpro",doc.data())
          });
    },
    closeAuthModal() {
      this.authModal = false
    },
    signout() {
      this.$store.dispatch("auth/logout");
    },
    //プロフィール情報更新
    setProfile(el) {
      this.appbarpro = false;
      this.theProfile = this.members
        .filter(function (object) {
          return object.uid == el;
        })
        .shift();
      console.log("theProfile" + this.theProfile, this.members, el);
      if(this.theProfile&&this.theProfile.message) this.message = this.theProfile.message
      if(this.theProfile&&this.theProfile.hitokoto) this.hitokoto = this.theProfile.hitokoto
      if(this.theProfile&&this.theProfile.relatedLink) this.proLink = this.theProfile.relatedLink
    },
    onecandiMembers(el) {
      this.candiMem = el;
    },
    oneaddMember(el) {
      this.memview = el;
    },
    oneaddAdmin(el) {
      this.adminsview = el;
    },
    closeSettings(el){
      this.settings = el
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + "/" + mm + "/" + dd + "  " + hh + ":" + mi + ":" + se
      //console.log("today",this.todayy)
    }    
  },
};
</script>

<style>
i.mdi-office-building-outline{
  font-size: 16px !important;
  margin-bottom:2px !important;
}
</style>

<style scoped>
.ws .v-list-group__header{
  height:32px !important;
}
.navilidr >>> .v-list-group__header__append-icon{
  display: none;
  background-color: #ffffff;
  height: 40px !important;
  margin-left: 0px !important;
  padding-right: 16px !important;
}
.navilidr >>> .v-list-group__header{
  padding-right:0px !important;
}
.lidbtn {
  background-color: #ffffff !important;
  color: #294A66 !important;
}
.selectedBack {
  background-color: #707070 !important;
}
.selectedFont {
  color: #ffffff;
}
.thispage {
  background-color: #ffffff !important;
  color: #294A66 !important;
  font-weight: bold;
}
.bottomarea{
  background-color: #294A66;
  z-index: 10;
  position: fixed;
  bottom: 0px;
  left: 0px;
}
.select {
  color: #294A66 !important;
  background-color: white;
}
.divider {
  color: #dcdcdc;
}
.basename {
  position: relative;
  top: 5px;
  left: -10px;
}
.icon {
  position: relative;
  top: 60px;
  left: -50px;
}
.childitembtn{
  justify-content: start;
}
.navdrawer >>> .v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}
.navdrawer >>> .v-navigation-drawer__content {
  overscroll-behavior: none;
}
.head >>> .v-toolbar__content {
  padding-left: 0px !important;
}
.listgroup >>> .v-list-item__icon {
  margin: 0px !important;
}
.listgroup >>> .v-list-group__header__prepend-icon {
  padding-top: 7% !important;
  padding-right: 4% !important;
  margin-right: 1% !important;
}
* {
  font-family: mplus-2c-medium;
}
.noneScBar::-webkit-scrollbar {
  display: none;
}
.ScBar::-webkit-scrollbar {
  width: 10px;
}
.ScBar::-webkit-scrollbar-track {
  background-color: rgba(120, 170, 210,0.3);
  border-radius: 100px;
}
.ScBar::-webkit-scrollbar-thumb {
  background: #78aad2;
  border-radius: 100px;
  width: 130px;
}
</style>